import axios from 'axios';
import { getCognitoToken } from './cognito';

const wemogaApi = axios.create({
  baseURL: process.env.REACT_APP_WEMOGA_API,
});

console.log('📋 REACT_APP_WEMOGA_API:', process.env.REACT_APP_WEMOGA_API);

wemogaApi.interceptors.request.use(async (config) => {
  try {
    console.log('📋 Configurando requisição para:', config.url);
    const token = await getCognitoToken();
    config.headers.Authorization = `Bearer ${token}`;
    
    console.log('📋 Headers da requisição:', JSON.stringify(config.headers));
    return config;
  } catch (error) {
    console.error('📋 Erro ao configurar requisição:', error);
    return Promise.reject(error);
  }
});

wemogaApi.interceptors.response.use(
  response => {
    console.log(`📋 Resposta bem-sucedida para ${response.config.url} - Status: ${response.status}`);
    return response;
  },
  error => {
    console.error('📋 Erro na resposta da API:', error.message);
    if (error.response) {
      console.error('📋 Status do erro:', error.response.status);
      console.error('📋 Dados do erro:', error.response.data);
    }
    return Promise.reject(error);
  }
);

export default wemogaApi;
